module.exports = __webpack_public_path__ + "img/img_gift.52f3f959.png";